import React from 'react';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { LineContent, BackgroundGradient, animationLine } from './commonStyles';

const Carousel = ({ device }) => {
  return (
    <Container className={`skeleton-carousel-${device}`}>
      <Card className={`skeleton-carousel-card-${device}`}>
        {device !== 'mobile' && <Header />}
        <Body className={`skeleton-carousel-card-body-${device}`}>
          {device !== 'mobile' && <LineContent width='171px' marginBottom='118px' />}
          <MiddleInfo className={`skeleton-carousel-card-middleInfo-${device}`}>
            <div>
              <LineContent width='43px' marginBottom='8px' />
              <LineContent width='125px' />
            </div>
            <Circle />
          </MiddleInfo>
          <Bottom device={device} />
        </Body>
      </Card>
      <Card className={`skeleton-carousel-card-${device}`}>
        {device !== 'mobile' && <Header />}
        <Body className={`skeleton-carousel-card-body-${device}`}>
          {device !== 'mobile' && <LineContent width='171px' marginBottom='118px' />}
          <MiddleInfo className={`skeleton-carousel-card-middleInfo-${device}`}>
            <div>
              <LineContent width='43px' marginBottom='8px' />
              <LineContent width='125px' />
            </div>
            <Circle />
          </MiddleInfo>
          <Bottom device={device} />
        </Body>
      </Card>
      <Card className={`skeleton-carousel-card-${device}`}>
        {device !== 'mobile' && <Header />}
        <Body className={`skeleton-carousel-card-body-${device}`}>
          {device !== 'mobile' && <LineContent width='171px' marginBottom='118px' />}
          <MiddleInfo className={`skeleton-carousel-card-middleInfo-${device}`}>
            <div>
              <LineContent width='43px' marginBottom='8px' />
              <LineContent width='125px' />
            </div>
            <Circle />
          </MiddleInfo>
          <Bottom device={device} />
        </Body>
      </Card>
      <Card className={`skeleton-carousel-card-${device}`}>
        {device !== 'mobile' && <Header />}
        <Body className={`skeleton-carousel-card-body-${device}`}>
          {device !== 'mobile' && <LineContent width='171px' marginBottom='118px' />}
          <MiddleInfo className={`skeleton-carousel-card-middleInfo-${device}`}>
            <div>
              <LineContent width='43px' marginBottom='8px' />
              <LineContent width='125px' />
            </div>
            <Circle />
          </MiddleInfo>
          <Bottom device={device} />
        </Body>
      </Card>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-width: 0;
  overflow: hidden;
  &.skeleton-carousel-desktop {
    margin-bottom: 69px;
  }
  &.skeleton-carousel-tablet {
    margin-bottom: 46px;
  }
  &.skeleton-carousel-mobile {
    margin-bottom: 0;
    :after {
      content: '';
      width: 100%;
      border-bottom: 1px solid ${select('middleGray')};
      margin-top: 33px;
      margin-bottom: 40px;
      display: block;
    }
  }
`;

const Card = styled.div`
  height: 409px;
  width: 399px;
  border-radius: 12px;
  box-shadow: -6px 0px 34px 7px rgba(196, 196, 196, 0.12);
  overflow: hidden;
  display: inline-flex;
  flex-direction: column;
  margin-right: 41px;
  &.skeleton-carousel-card-mobile {
    height: 423px;
    width: 282px;
    background-color: ${select('middleGray')};
  }
`;

const Header = styled.div`
  width: 100%;
  height: 57px;
  background-color: ${select('middleGray')};
`;

const Body = styled.div`
  width: 100%;
  flex: 1;
  padding: 32px 29px 28px 30px;
  &.skeleton-carousel-card-body-mobile {
    height: 100%;
    padding: 210px 15px 14px 8px;
  }
`;

const MiddleInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 46px;
  &.skeleton-carousel-card-middleInfo-mobile {
    width: 100%;
    height: 106px;
    border-radius: 12px 12px 10px 10px;
    background-color: white;
    margin-bottom: 48px;
    padding: 7px 16px;
  }
`;

const Circle = styled.div`
  height: 66px;
  width: 66px;
  border-radius: 50%;
  ${BackgroundGradient};
  ${animationLine};
`;

const Bottom = styled.div`
  width: 100%;
  height: 41px;
  background-color: ${({ device }) => (device !== 'mobile' ? select('middleGray') : 'white')};
  border-radius: 12px 12px 10px 10px;
`;

export default Carousel;
